(function ($) {
    $(document).ready(function () {
        if ($(".timeline-bottom-sticky").length > 0) {

            $(".timeline-bottom-sticky ul li a").on("click", function (e) {
                e.preventDefault();
                // $(".timeline-bottom-sticky ul li").removeClass("active");
                // $(this).parent().addClass("active");
                $('.timeline-bottom-sticky .row-wrapper').removeClass('active');
                $(".mobile-nav").empty();
                $(this).parent().clone().appendTo(".mobile-nav");
            });

            var stickyOffsetTop = $(".timeline-bottom-sticky").offset().top + $(".secondary-nav").outerHeight();
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                if (scroll <= stickyOffsetTop) {
                    $(".timeline-bottom-sticky").addClass("fixed-nav");
                }
                // else {
                //     $(".timeline-bottom-sticky").removeClass("fixed-nav");
                // }
            });
            $('.timeline-bottom-sticky .mobile-nav').on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                $('.timeline-bottom-sticky .row-wrapper').toggleClass('active');
            });

            setTimeout(function () {
                $(".timeline-bottom-sticky").css("opacity", "1");
            }, 500);

            $(document).on("click", function () {
                $(".row-wrapper").removeClass("active");
            });

            $('.timeline-bottom-sticky ul li a').on('click', function(e){
                e.preventDefault();
                var href = $(this).attr('href');
                $('html, body').animate({
                    scrollTop: $(href).offset().top - $(".header").height()
                },500);
            });



            var minusHeight = $(".timeline-bottom-sticky").outerHeight() + $("header").outerHeight();
            $(window).on("load scroll", function () {
                var scroll = $(window).scrollTop();

                var activeSelector = $('section');
                var nav = $('.timeline-bottom-sticky ul');

                activeSelector.each(function () {
                    var top = $(this).offset().top  - minusHeight  - 100,
                        bottom = top + $(this).outerHeight();
                    if (scroll >= top && scroll <= bottom) {
                        nav.find('a[href="#' + $(this).attr("id") + '"]').parent("li").addClass("active");
                    }
                    else if (scroll >= top) {
                        nav.find('a[href="#' + $(this).attr("id") + '"]').parent("li").addClass("active");
                    }
                    else if (scroll <= bottom) {
                        nav.find('a[href="#' + $(this).attr("id") + '"]').parent("li").removeClass("active");
                    }
                });
            });

        }
    });


})(jQuery);

